module.exports = __webpack_public_path__ + "static/img/son12_active.a58df707.png";